import { PROFILE_FAVORITES } from "@/libs/apis/onboarding/reactQueryCacheKeys";
import { useCurrentUserFavoritedTokens } from "@/src/routes/gallery/routes/collections/routes/[collectionName]/components/CollectionTokenListings/hooks/useCurrentUserFavoritedTokens";
import { NFTContract } from "../../../types";

export const useFavoritedCards = (
  nfts: NFTContract[],
  swooshHandle: string,
) => {
  const tokenIds = nfts?.map((nft) => nft.tokenId);
  const currentUserFavoritedTokens = useCurrentUserFavoritedTokens({
    tokenIds: tokenIds as string[],
    /**
     * @note Currently, both the contractAddress and chainId passed in is being ignored by the API
     * @todo remove contract address and chain Id after API has been refactored
     * @see https://jira.nike.com/browse/NVS-2817
     */
    contractAddress: nfts?.at(0)?.contractAddress as string,
    chainId: 80001,
    keys: [PROFILE_FAVORITES, swooshHandle, createTokenIdList(nfts)],
  });
  return currentUserFavoritedTokens;
};

export const createTokenIdList = (nfts: NFTContract[]) =>
  nfts.map((token) => token.tokenId).join(",");
